module.exports = "/images/vendor/flag-icon-css/flags/4x3/gh.svg?caedb9129bf6bd63ff4081a0ba91e113";